import React from 'react';
import { Box, Drawer, ListItem, List, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { NavLink } from 'react-router-dom';

interface CustomDrawerProps {
    drawerOpen: boolean;
    handleDrawerToggle: () => void;
}

const useStyles = makeStyles(() => ({
    listItem: {
        display: 'flex',
        justifyContent: 'center !important',
        textDecoration: 'none',
        color: 'black',
        marginBottom: 15,
        borderRadius: 20,
        '&:hover': {
            backgroundColor: '#CCCCCC',
            color: '#044769'
        },
        '&.active': {
            color: '#044769'
        }
    },
    lastListItem: {
        display: 'flex',
        justifyContent: 'center !important'
    }
}));

const CustomDrawer: React.FunctionComponent<CustomDrawerProps> = (props) => {
    const { drawerOpen, handleDrawerToggle } = props;
    const classes = useStyles();

    return (
        <Drawer anchor="top" open={drawerOpen} onClose={handleDrawerToggle}>
            <Box m={2}>
                <List>
                    <ListItem className={classes.listItem} component={NavLink} to="/" onClick={handleDrawerToggle}>
                        <Typography>Home</Typography>
                    </ListItem>
                    <ListItem className={classes.listItem} component={NavLink} to="/" onClick={handleDrawerToggle}>
                        <Typography>About</Typography>
                    </ListItem>
                    <ListItem className={classes.listItem} component={NavLink} to="/" onClick={handleDrawerToggle}>
                        <Typography>Contact Us</Typography>
                    </ListItem>
                    <ListItem
                        className={classes.listItem}
                        component={NavLink}
                        to="/spaCoverOverview"
                        onClick={handleDrawerToggle}
                    >
                        <Typography>Spa Cover</Typography>
                    </ListItem>
                    <ListItem
                        className={classes.listItem}
                        component={NavLink}
                        to="/safetyCoverOverview"
                        onClick={handleDrawerToggle}
                    >
                        <Typography>Safety Cover</Typography>
                    </ListItem>
                    <ListItem
                        className={classes.listItem}
                        component={NavLink}
                        to="/spaCoverSummary"
                        onClick={handleDrawerToggle}
                    >
                        <Typography>Customize your cover</Typography>
                    </ListItem>
                    
                  
                </List>
            </Box>
        </Drawer>
    );
};

export default CustomDrawer;
